import React from "react";
import ReactDOM from "react-dom";
import "@/index.css";
import reportWebVitals from "@/reportWebVitals";
import { loadAppConfig } from "@/appConfig";
import { logVersion } from "./rewrite/version";

const rootEl = document.getElementById("root");

logVersion();

function ConfigError({ error }: { error: unknown }) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <div className="p-[24px] max-w-[640px] mx-auto">
      <h1 className="text-lg font-semibold mb-2">Unable to start</h1>
      <p className="mb-2">
        The application configuration could not be loaded, so the app cannot start.
      </p>
      <pre className="text-sm bg-gray-100 p-2 rounded whitespace-pre-wrap">{message}</pre>
    </div>
  );
}

// AppConfig must be fetched and applied to imageFiles.ts BEFORE the App
// module graph is evaluated, because several SVG editors snapshot values derived
// from octSettings at import time. Loading defaults first and then dynamically
// importing App guarantees that ordering.
loadAppConfig()
  .then(async () => {
    const { default: App } = await import("./App");
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      rootEl
    );
  })
  .catch((error) => {
    // Fetching/validating the config is treated as fatal: block with an error
    // screen rather than rendering the wizard with stale defaults.
    console.error("Failed to load app defaults:", error);
    ReactDOM.render(
      <React.StrictMode>
        <ConfigError error={error} />
      </React.StrictMode>,
      rootEl
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
